
function CRUDth({ th }) {
    return (
        <th>{th}</th>
    )
}

export default CRUDth